import React from 'react'
import Session from './Session'
import { Provider } from './CurrentUserContext'
import { Query } from 'react-apollo'
import CURRENT_USER_QUERY from './CurrentUserProvider.query'

const CurrentUserProvider = ({ children }) => (
  <Session
    render={({ authenticated }) =>
      authenticated ? (
        <Query query={CURRENT_USER_QUERY} variables={{ authenticated }}>
          {({ loading, data }) => (
            <Provider value={{ loading, viewer: data && data.viewer }}>
              {children}
            </Provider>
          )}
        </Query>
      ) : (
        <Provider value={{ loading: false, viewer: null }}>{children}</Provider>
      )
    }
  />
)

export default CurrentUserProvider



// WEBPACK FOOTER //
// ./src/components/CurrentUserProvider.js